<template>
  <div class="point-home">
    <!-- banner -->
    <van-row class="banner">
      <van-col span="24">
        <img class="image" src="@/assets/images/points_gift.png" />
      </van-col>
    </van-row>
    <!-- 个人信息 -->
    <!-- <van-row class="personal">
      <van-col span="24">
        <div class="info">
          <div>
            <van-image
              round
              class="avatar"
              src="https://img.yzcdn.cn/vant/apple-1.jpg"
            />
          </div>
          <span class="points">积分: 100</span>
        </div>
      </van-col>
    </van-row> -->
    <!-- 积分商品列表 -->
    <van-row>
      <van-col span="24">
        <points-list></points-list>
      </van-col>
    </van-row>
  </div>
</template>

<script>
  import Vue from "vue";
  import PointsList from '@/components/PointsList.vue'
  export default {
    name: "PointsHome",
    components: {
      PointsList
    },
    data() {
      return {};
    },
    methods: {},
    mounted() {},
  };
</script>

<style scoped>
  .point-home {
    background-color: #f2f3f4;
  }

  .point-home .banner .image {
    height: 2.5rem;
    width: 100%;
  }

  .personal .info {
    position: absolute;
    top: 0.5em;
    left: 0.5em;
    width: 2.2rem;
    height: 2.2rem;
    background-color: #fff;
    border-radius: 25%;
    text-align: center;
    padding: 0.9em;
    filter: alpha(Opacity=70);
    -moz-opacity: 0.7;
    opacity: 0.7;
  }

  .personal .info .avatar {
    width: 1.3rem;
    height: 1.3rem;
  }

  .personal .info .points {
    color: #333;
    font-size: 0.9em;
    font-weight: bold;
  }
</style>
